export default "__VITE_ASSET__Dn0uU$r0__"